export default "__VITE_ASSET__eb645313__"